export type SeriesRecordIdentity = {
  seriesId?: string | null;
  name?: string | null;
};

const normalizeSeriesName = (value: string | null | undefined): string =>
  String(value || '').trim().toLocaleLowerCase();

export const resolveSeriesIdForName = (
  options: SeriesRecordIdentity[],
  name: string,
  preferredSeriesId?: string | null
): string | null => {
  const normalizedName = normalizeSeriesName(name);
  if (!normalizedName) return null;

  const matches = options.filter(
    option => option.seriesId && normalizeSeriesName(option.name) === normalizedName
  );
  if (!matches.length) return null;

  if (preferredSeriesId) {
    const preferredMatch = matches.find(option => option.seriesId === preferredSeriesId);
    if (preferredMatch?.seriesId) return preferredMatch.seriesId;
  }

  return matches[0]?.seriesId || null;
};
